import { z } from 'zod';

export type AssetStateRecord<T> = { value: T | undefined; ts: Date | undefined };

export const AssetStateRecord = <T>(valueType: z.ZodType<T>) =>
    z
        .object({
            value: valueType.optional().catch(undefined),
            ts: z.coerce.date().optional().catch(undefined),
        })
        .optional()
        .catch(undefined);
